<template>
  <!-- 赠品 -->
  <div>
    <!-- con_pad_l 失效时去掉 -->
    <div
      :class="{
        border_top1px: showLine,
        con_pad_l: freeProduct.status !== 0
      }"
      class="free_con"
      @click="goOrderDetail(orderSn)"
    >
      <div class="content clearfix">
        <div
          v-if="freeProduct.status === 0"
          class="none_icon left font10 font_weight400 colof line_height_14"
        >
          失效
        </div>
        <div class="left pro_img_con">
          <div class="product_img">
            <img :src="freeProduct.skuPic" alt="" class="img_img" />
            <img
              src="@/assets/product/icon_right_free@2x.png"
              alt=""
              class="img_icon"
            />
          </div>
        </div>
        <div class="name left text_left font_weight400">
          <div class="font12 colo0 name_name">
            {{ freeProduct.skuName }}
          </div>
          <div class="name_spec clearfix">
            <div
              :class="{ spec_bg: showBor }"
              class="left spec_det font10 text_left font_weight400 colo055 line_height_16 font_line_1"
            >
              规格：{{ freeProduct.skuSpec }}
            </div>
            <img
              src="@/assets/common/icon_cell_more_24@2x.png"
              alt=""
              class="left more_icon"
              v-if="showBor"
            />
          </div>
        </div>
        <div class="right">
          <div
            v-if="
              freeProduct.orderDetailLowerList &&
                freeProduct.orderDetailLowerList.length
            "
            class="font9 some_tag"
          >
            分开发货
          </div>
          <div
            :class="
              freeProduct.orderDetailLowerList &&
              freeProduct.orderDetailLowerList.length
                ? 'free_price1'
                : 'free_price'
            "
            class="font16 font_weight600 colo087 line_height_19"
          >
            {{
              freeProduct.skuNowPrice || freeProduct.skuPrice | currency(false)
            }}
          </div>
          <div class="font12 font_weight400 colo087 line_height_14">
            ×{{ freeProduct.skuAmount || freeProduct.amount }}
          </div>
        </div>
      </div>
    </div>
    <!-- 组合商品显示 -->
    <div
      v-if="
        freeProduct.orderDetailLowerList &&
          freeProduct.orderDetailLowerList.length
      "
    >
      <div
        v-for="(i, index1) in freeProduct.orderDetailLowerList"
        :key="index1"
        class="order_product2"
      >
        <div class="product_img_order2">
          <img :src="i.skuPic" alt="" />
        </div>
        <div class="right_item_pad">
          <!-- <div class="name_mr2"> -->
          <div
            class="name_name2 font12 font_weight400 colo055 font_line_2 text_left line_height_17"
          >
            {{ i.skuName }}
          </div>
          <!-- </div> -->
          <div class="font14 font_weight600 colo087 line_height_16 spec_2">
            <div class="font10 font_weight400 colo055 text_left">
              规格：{{ i.skuSpec }}
            </div>
            <div class="price_num font12 font_weight400 colo055 line_height_14">
              ×{{ i.modifyNum || i.amount || i.skuAmount }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    freeProduct: {
      type: Object,
      default() {
        return {};
      }
    },
    orderSn: {
      type: String,
      default: ""
    },
    showBor: {
      type: Boolean,
      default: false
    },
    showLine: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    goOrderDetail(orderSn) {
      if (orderSn) {
        this.$emit("goOrderDetail", orderSn);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.con_pad_l {
  padding: 12px 0;
}
.free_con {
  background: #fff;
  // border: 0;
  .content {
    // padding: 12px 0 0;
    .none_icon {
      background: rgba(0, 0, 0, 0.38);
      border-radius: 2px;
      padding: 4px 1px;
      margin: 17px 10px 0 0;
    }
    .btn {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 20px;
      margin-top: 135px;
    }
    .free_pad {
      padding-bottom: 12px;
    }
    .icon_free {
      width: 32px;
      margin-right: 8px;
    }
    .pro_img_con {
      width: 96px;
      height: 96px;
    }
    .product_img {
      position: relative;
      font-size: 0;
      .img_img {
        width: 100%;
      }
      .img_icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 31px;
      }
    }
    .name {
      padding: 12px 0 0 12px;
      .name_name {
        width: 152px;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .name_det {
        padding-top: 13px;
      }
    }
    .name_spec {
      margin-top: 11px;
      .spec_det {
        max-width: 90px;
        overflow-y: hidden;
      }
      .spec_bg {
        background: rgba(0, 0, 0, 0.03);
        border-radius: 2px;
      }
      .more_icon {
        width: 16px;
      }
      .delete_icon {
        width: 16px;
      }
    }
  }
  .free_price {
    margin: 22px 0 7px;
  }
  .free_price1 {
    margin: 10px 0 7px;
  }
}
.order_product2 {
  margin-left: 108px;
  display: flex;
  border-top: 1px dashed rgba(0, 0, 0, 0.2);
  padding-top: 12px;
  margin-right: 12px;
  .product_img_order2 {
    width: 56px;
    height: 70px;
    img {
      width: 100%;
      max-height: 70px;
    }
  }
  .spec_2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 5px;
  }
  .right_item_pad {
    margin-left: 12px;
  }
  .name_mr2 {
    width: 100%;
  }
  // .name_name2 {
  //   max-width: 152px;
  // }
}
.some_tag {
  margin-top: 12px;
  background: rgba(83, 121, 196, 0.12);
  border: 1px solid #5379c4;
  border-radius: 2px;
  font-size: 9px;
  font-weight: 400;
  color: #5379c4;
}
</style>
